import React from 'react';
import { useLayout } from '../contexts/LayoutContext';
import TopNavLayout from './layouts/TopNavLayout';
import SidebarLayout from './layouts/SidebarLayout';

const LayoutWrapper: React.FC = () => {
  const { preferences } = useLayout();

  if (preferences.layoutMode === 'sidebar') {
    return <SidebarLayout />;
  }

  return <TopNavLayout />;
};

export default LayoutWrapper;